import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {accountAuditLogStateSelector} from './account-audit-log-state.slice';

import type {AccountAuditLogCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {LogHits} from 'src/openapi/admin/models/LogHits';


export const accountAuditLogSlice = getCachedTableDataSlice<
    LogHits[],
    undefined,
    undefined,
    AccountAuditLogCriteria
>('accountAuditLog');

export const accountAuditLogActions = accountAuditLogSlice.actions;
const accountAuditLogCacheSelector: CachedTableCacheSelector<LogHits[]>
    = state => state.accountPage.tabs.accountAuditLog.events.cache;
export const accountAuditLogDataSelector: CachedTableDataSelector<LogHits[]>
    = state => state.accountPage.tabs.accountAuditLog.events;
export const accountAuditLogResultSelector = getCachedTableResultSelector(
    accountAuditLogCacheSelector,
    accountAuditLogStateSelector,
);
